import React from "react";
import { Helmet } from "react-helmet-async";
import {
  ORGANIZATION_ID,
  SHIPPING_POLICY_ID,
  RETURN_POLICY_ID,
} from "./SchemaHelpers";

export default function Seo({
  title,
  description,
  canonical,
  image = "https://parishaudio.com/assets/og-default.jpg",
  imageAlt = "Parish Audio",
  ogType = "website",
  robots = "index,follow",
  schema = null,
  noindex = false,
}) {
  const resolvedRobots = noindex ? "noindex,nofollow" : robots;

  const onlineStoreSchema = {
    "@context": "https://schema.org",
    "@type": "OnlineStore",
    "@id": ORGANIZATION_ID,
    name: "Parish Audio",
    alternateName: "Parish Audio",
    url: "https://parishaudio.com",
    logo: "https://parishaudio.com/assets/logo.png",
    image: "https://parishaudio.com/assets/og-default.jpg",
    description:
      "Parish Audio creates professional audio plugins for guitar, mixing, sound design, and music production.",
    email: "support@parishaudio.com",
    contactPoint: [
      {
        "@type": "ContactPoint",
        email: "support@parishaudio.com",
        contactType: "customer support",
        availableLanguage: ["English"],
      },
    ],
    sameAs: ["https://x.com/Parish_Audio"],
    areaServed: "Worldwide",
    knowsAbout: [
      "Audio plugins",
      "VST3 plugins",
      "Guitar effects",
      "Reverb plugins",
      "Delay plugins",
      "Overdrive plugins",
      "Noise gate plugins",
      "Music production software",
    ],
    hasShippingService: {
      "@type": "ShippingService",
      "@id": SHIPPING_POLICY_ID,
      name: "Instant download delivery",
      description:
        "All Parish Audio products are delivered as instant downloads with no shipping cost and no handling or transit delay.",
      handlingTime: {
        "@type": "ServicePeriod",
        duration: {
          "@type": "QuantitativeValue",
          minValue: 0,
          maxValue: 0,
          unitCode: "DAY",
        },
      },
      shippingConditions: [
        {
          "@type": "ShippingConditions",
          shippingRate: {
            "@type": "MonetaryAmount",
            value: 0,
            currency: "USD",
          },
          transitTime: {
            "@type": "ServicePeriod",
            duration: {
              "@type": "QuantitativeValue",
              minValue: 0,
              maxValue: 0,
              unitCode: "DAY",
            },
          },
        },
      ],
    },
    hasMerchantReturnPolicy: {
      "@type": "MerchantReturnPolicy",
      "@id": RETURN_POLICY_ID,
      merchantReturnLink: "https://parishaudio.com/return-policy",
    },
  };

  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "@id": "https://parishaudio.com/#website",
    url: "https://parishaudio.com",
    name: "Parish Audio",
    description:
      "Professional audio plugins for mixing, sound design, guitar, and modern music production.",
    publisher: {
      "@id": ORGANIZATION_ID,
    },
    inLanguage: "en-US",
  };

  const schemas = [
    onlineStoreSchema,
    websiteSchema,
    ...(schema
      ? Array.isArray(schema)
        ? schema
        : [schema]
      : []),
  ];

  return (
    <Helmet prioritizeSeoTags>
      {title && <title>{title}</title>}

      {description && <meta name="description" content={description} />}
      {resolvedRobots && <meta name="robots" content={resolvedRobots} />}
      {canonical && <link rel="canonical" href={canonical} />}

      <meta charSet="utf-8" />
      <meta property="og:site_name" content="Parish Audio" />
      <meta property="og:locale" content="en_US" />
      {ogType && <meta property="og:type" content={ogType} />}
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      {canonical && <meta property="og:url" content={canonical} />}
      {image && <meta property="og:image" content={image} />}
      {imageAlt && <meta property="og:image:alt" content={imageAlt} />}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@Parish_Audio" />
      {title && <meta name="twitter:title" content={title} />}
      {description && <meta name="twitter:description" content={description} />}
      {image && <meta name="twitter:image" content={image} />}
      {imageAlt && <meta name="twitter:image:alt" content={imageAlt} />}

      {schemas.map((item, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(item)}
        </script>
      ))}
    </Helmet>
  );
}

// import React from "react";
// import { Helmet } from "react-helmet-async";

// export default function Seo({
//   title,
//   description,
//   canonical,
//   image = "https://parishaudio.com/assets/og-default.jpg",
//   imageAlt = "Parish Audio",
//   ogType = "website",
//   robots = "index,follow",
//   schema = null,
//   noindex = false,
// }) {
//   const resolvedRobots = noindex ? "noindex,nofollow" : robots;

//   const onlineStoreSchema = {
//     "@context": "https://schema.org",
//     "@type": "OnlineStore",
//     "@id": "https://parishaudio.com/#organization",
//     name: "Parish Audio",
//     alternateName: "Parish Audio",
//     url: "https://parishaudio.com",
//     logo: "https://parishaudio.com/assets/logo.png",
//     image: "https://parishaudio.com/assets/og-default.jpg",
//     description:
//       "Parish Audio creates professional audio plugins for guitar, mixing, sound design, and music production.",
//     email: "support@parishaudio.com",
//     contactPoint: [
//       {
//         "@type": "ContactPoint",
//         email: "support@parishaudio.com",
//         contactType: "customer support",
//         availableLanguage: ["English"],
//       },
//     ],
//     sameAs: [
//       "https://x.com/Parish_Audio",
//     ],
//     areaServed: "Worldwide",
//     knowsAbout: [
//       "Audio plugins",
//       "VST3 plugins",
//       "Guitar effects",
//       "Reverb plugins",
//       "Delay plugins",
//       "Overdrive plugins",
//       "Noise gate plugins",
//       "Music production software",
//     ],

//     hasShippingService: {
//       "@type": "ShippingService",
//       "@id": "https://parishaudio.com/#shipping-policy",
//       name: "Instant download delivery",
//       description:
//         "All Parish Audio products are delivered as instant downloads with no shipping cost and no handling or transit delay.",
//       shippingConditions: {
//         "@type": "ShippingConditions",
//         shippingRate: {
//           "@type": "MonetaryAmount",
//           value: "0",
//           currency: "USD",
//         },
//         deliveryTime: {
//           "@type": "ShippingDeliveryTime",
//           handlingTime: {
//             "@type": "QuantitativeValue",
//             minValue: 0,
//             maxValue: 0,
//             unitCode: "DAY",
//           },
//           transitTime: {
//             "@type": "QuantitativeValue",
//             minValue: 0,
//             maxValue: 0,
//             unitCode: "DAY",
//           },
//         },
//       },
//     },

//     hasMerchantReturnPolicy: {
//       "@type": "MerchantReturnPolicy",
//       "@id": "https://parishaudio.com/#return-policy",
//       merchantReturnLink: "https://parishaudio.com/return-policy",
//     },
//   };

//   const websiteSchema = {
//     "@context": "https://schema.org",
//     "@type": "WebSite",
//     "@id": "https://parishaudio.com/#website",
//     url: "https://parishaudio.com",
//     name: "Parish Audio",
//     description:
//       "Professional audio plugins for mixing, sound design, guitar, and modern music production.",
//     publisher: {
//       "@id": "https://parishaudio.com/#organization",
//     },
//     inLanguage: "en-US",
//   };

//   const schemas = [
//     onlineStoreSchema,
//     websiteSchema,
//     ...(schema
//       ? Array.isArray(schema)
//         ? schema
//         : [schema]
//       : []),
//   ];

//   return (
//     <Helmet prioritizeSeoTags>
//       {title && <title>{title}</title>}

//       {description && <meta name="description" content={description} />}
//       {resolvedRobots && <meta name="robots" content={resolvedRobots} />}
//       {canonical && <link rel="canonical" href={canonical} />}

//       <meta charSet="utf-8" />
//       <meta property="og:site_name" content="Parish Audio" />
//       <meta property="og:locale" content="en_US" />
//       {ogType && <meta property="og:type" content={ogType} />}
//       {title && <meta property="og:title" content={title} />}
//       {description && <meta property="og:description" content={description} />}
//       {canonical && <meta property="og:url" content={canonical} />}
//       {image && <meta property="og:image" content={image} />}
//       {imageAlt && <meta property="og:image:alt" content={imageAlt} />}

//       <meta name="twitter:card" content="summary_large_image" />
//       <meta name="twitter:site" content="@Parish_Audio" />
//       {title && <meta name="twitter:title" content={title} />}
//       {description && <meta name="twitter:description" content={description} />}
//       {image && <meta name="twitter:image" content={image} />}
//       {imageAlt && <meta name="twitter:image:alt" content={imageAlt} />}

//       {schemas.map((item, index) => (
//         <script key={index} type="application/ld+json">
//           {JSON.stringify(item)}
//         </script>
//       ))}
//     </Helmet>
//   );
// }

// import React from "react";
// import { Helmet } from "react-helmet-async";

// export default function Seo({
//   title,
//   description,
//   canonical,
//   image = "https://parishaudio.com/assets/og-default.jpg",
//   imageAlt = "Parish Audio",
//   ogType = "website",
//   robots = "index,follow",
//   schema = null,
// }) {
//   const organizationSchema = {
//     "@context": "https://schema.org",
//     "@type": "Organization",
//     name: "Parish Audio",
//     url: "https://parishaudio.com",
//     logo: "https://parishaudio.com/assets/logo.png",
//     contactPoint: {
//       "@type": "ContactPoint",
//       email: "support@parishaudio.com",
//       contactType: "customer support",
//     },
//   };

//   const schemas = schema
//     ? Array.isArray(schema)
//       ? [organizationSchema, ...schema]
//       : [organizationSchema, schema]
//     : [organizationSchema];

//   return (
//     <Helmet>
//       {title && <title>{title}</title>}

//       {description && <meta name="description" content={description} />}
//       {robots && <meta name="robots" content={robots} />}
//       {canonical && <link rel="canonical" href={canonical} />}

//       <meta property="og:site_name" content="Parish Audio" />
//       <meta property="og:locale" content="en_US" />
//       {ogType && <meta property="og:type" content={ogType} />}
//       {title && <meta property="og:title" content={title} />}
//       {description && <meta property="og:description" content={description} />}
//       {canonical && <meta property="og:url" content={canonical} />}
//       {image && <meta property="og:image" content={image} />}
//       {imageAlt && <meta property="og:image:alt" content={imageAlt} />}

//       <meta name="twitter:card" content="summary_large_image" />
//       {title && <meta name="twitter:title" content={title} />}
//       <meta name="twitter:site" content="@Parish_Audio" />
//       {description && <meta name="twitter:description" content={description} />}
//       {image && <meta name="twitter:image" content={image} />}
//       {imageAlt && <meta name="twitter:image:alt" content={imageAlt} />}

//       {schemas.map((item, index) => (
//         <script key={index} type="application/ld+json">
//           {JSON.stringify(item)}
//         </script>
//       ))}
//     </Helmet>
//   );
// }



// // import React from "react";
// // import { Helmet } from "react-helmet-async";

// // export default function Seo({
// //   title,
// //   description,
// //   canonical,
// //   image = "https://parishaudio.com/assets/og-default.jpg",
// //   imageAlt = "Parish Audio",
// //   ogType = "website",
// //   robots = "index,follow",
// //   schema = null,
// // }) {
// //   const businessSchema = {
// //     "@context": "https://schema.org",
// //     "@type": "Organization",
// //     name: "Parish Audio",
// //     url: "https://parishaudio.com",
// //     logo: "https://parishaudio.com/assets/logo.png",
// //     contactPoint: {
// //       "@type": "ContactPoint",
// //       email: "support@parishaudio.com",
// //       contactType: "customer support",
// //     },
// //   };

// //   const schemas = schema
// //     ? Array.isArray(schema)
// //       ? [businessSchema, ...schema]
// //       : [businessSchema, schema]
// //     : [businessSchema];

// //   return (
// //     <Helmet>
// //       <title>{title}</title>

// //       <meta name="description" content={description} />
// //       <meta name="robots" content={robots} />
// //       <link rel="canonical" href={canonical} />

// //       <meta property="og:type" content={ogType} />
// //       <meta property="og:site_name" content="Parish Audio" />
// //       <meta property="og:title" content={title} />
// //       <meta property="og:description" content={description} />
// //       <meta property="og:url" content={canonical} />
// //       <meta property="og:image" content={image} />
// //       <meta property="og:image:alt" content={imageAlt} />

// //       <meta name="twitter:card" content="summary_large_image" />
// //       <meta name="twitter:title" content={title} />
// //       <meta name="twitter:description" content={description} />
// //       <meta name="twitter:image" content={image} />

// //       {schemas.map((item, index) => (
// //         <script key={index} type="application/ld+json">
// //           {JSON.stringify(item)}
// //         </script>
// //       ))}
// //     </Helmet>
// //   );
// // }

// // import React from "react";

// // export default function Seo({ title, description, canonical }) {
// //   const jsonLd = {
// //     "@context": "https://schema.org",
// //     "@type": "ProfessionalService",
// //     name: "Parish Audio",
// //     url: "https://parishaudio.com",
// //     areaServed: "Worldwide",
// //     address: {
// //       "@type": "PostalAddress",
// //       addressLocality: "Burley",
// //       addressRegion: "ID",
// //       addressCountry: "US",
// //     },
// //     contactPoint: {
// //       "@type": "ContactPoint",
// //       email: "support@parishaudio.com",
// //       contactType: "customer support",
// //     },
// //   };

// //   return (
// //     <>
// //       <title>{title}</title>
// //       <meta name="description" content={description} />
// //       <link rel="canonical" href={canonical} />

// //       {/* Open Graph */}
// //       <meta property="og:type" content="website" />
// //       <meta property="og:title" content={title} />
// //       <meta property="og:description" content={description} />
// //       <meta property="og:url" content={canonical} />

// //       {/* Twitter */}
// //       <meta name="twitter:card" content="summary_large_image" />
// //       <meta name="twitter:title" content={title} />
// //       <meta name="twitter:description" content={description} />

// //       {/* Structured data */}
// //       <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
// //     </>
// //   );
// // }